import {
  Injectable,
  ComponentRef,
  ViewContainerRef,
  ApplicationRef,
  Injector,
  EmbeddedViewRef,
  ElementRef
} from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GetMultiMessagesService } from '../../shared/get-multi-messages.service';
import { PlessDialogService } from '../../shared/pless-dialog-service';
import { PlessAlert } from '../../shared/pless-alert/pless-alert.component';
import { PlessAlertSubComponent } from './pless-alert/pless-alert-sub.component';

/**
 * ダイアログ表示を提供するサービス
 *
 * @export
 * @class PlessDialogMultiMessageServiceSub
 */
@Injectable()
export class PlessDialogMultiMessageServiceSub extends PlessDialogService {
  /** 対象Elementに付与するCLASS名(zIndexの探索に使用) */
  private CLASS_NAME = 'pless-title-window';

  /**
   *Creates an instance of PlessDialogMultiMessageServiceSub.
   * @param {NgbModal} modalServiceSub
   * @memberof PlessDialogMultiMessageServiceSub
   */
  constructor(
    private getMultiMessagesService: GetMultiMessagesService,
    private modalServiceSub: NgbModal
  ) {
    super(
      modalServiceSub
    );
  }

  /**
   * 受け取ったメッセージIDをもとに、
   * messages.xmlからデータを検索し、アラートを表示。
   *
   * @param {string} mesId メッセージID 兼 アラートのタイトル
   * @param {Array<string>} [replaceStr] 置換文字列
   * @param {Function} [closeHander] 閉じる時に実行する処理
   * @memberof PlessDialogService
   */
  openAlertGetMessage(mesIdArray: Array<string>, replaceStr?: Array<Array<string>>, success?: boolean, closeHander?: Function) {
    let text = String('システムエラーが発生しました。\nシステム管理者までご連絡ください。');
    const title = "エラー";
    let buttons: Array<PlessAlert> = [PlessAlert.Yes_Error];
    let defaultButton = Number(4);

    // messages.xmlのデータ取得サービス呼び出し
    this.getMultiMessagesService.execute(mesIdArray, replaceStr, (message: any) => { 
      text = (success ? "選定が完了しました。\n": "") + message;
      const ref = this.openModal(PlessAlertSubComponent);
      const instance = ref.componentInstance as PlessAlertSubComponent;
      instance.setData(text, title, buttons, defaultButton);
      instance.closeHander = closeHander;
      instance.closeFunction = () => {
        ref.close();
      };
    });
  }

  /**
   * 最前面に表示する
   *
   * @private
   * @memberof PlessDialogServiceSub
   */
  private bringToFront(childComponent: any) {
    const zIndex: number = childComponent.elementRef.nativeElement.children[0].style.zIndex;
    const maxZIndex = this.getMaxZIndex();
    // 自身より前面に表示されているものを背面に回す
    this.sendToBack(zIndex);
    // 自身を最前面に表示する
    childComponent.elementRef.nativeElement.children[0].style.zIndex = maxZIndex.toString();
  }

  /**
   * 自身より前に表示されているものは背面に送る(zIndexを-1する)
   *
   * @private
   * @param {number} targetZIndex
   * @memberof PlessDialogServiceSub
   */
  private sendToBack(targetZIndex: number): void {
    const defaultView = document.defaultView;
    const elements = document.getElementsByClassName(this.CLASS_NAME);
    const length = elements.length;
    for (let i = Number(0); i < length; i++) {
      const element = elements[i];
      let zIndex = element['style'].zIndex;
      if (!zIndex) {
        const css = element['currentStyle'] || defaultView.getComputedStyle(element, null);
        zIndex = css ? css.zIndex : 0;
      }
      zIndex -= 0;
      if (zIndex > targetZIndex) {
        zIndex--;
        element['style'].zIndex = zIndex;
      }
    }
  }

  /**
   * 表示しているplessTitleWindowのzIndex最大値を取得する
   *
   * @private
   * @returns {number}
   * @memberof PlessDialogServiceSub
   */
  private getMaxZIndex(): number {
    let maxZIndex = PlessDialogService.MIN_Z_INDEX;
    const defaultView = document.defaultView;
    const elements = document.getElementsByClassName(this.CLASS_NAME);
    const length = elements.length;
    for (let i = Number(0); i < length; i++) {
      const element = elements[i];
      let zIndex = element['style'].zIndex;
      if (!zIndex) {
        const css = element['currentStyle'] || defaultView.getComputedStyle(element, null);
        zIndex = css ? css.zIndex : 0;
      }
      zIndex -= 0;
      if (maxZIndex < zIndex) {
        maxZIndex = zIndex;
      }
    }
    return maxZIndex;
  }

  /**
   * ポップアップ画面を閉じる。<br/>
   * PopUpManager.removePopUp()との違いは、渡された型と一致したポップアップウィンドウを削除する点。<br/>
   * 配列からの削除処理はdeletePopUpメソッドに依頼しているので、詳しくはそちらを参照。<br/>
   *
   * @param className 削除したいポップアップウィンドウの型
   *
   * @return 削除を行ったかどうかのフラグ。true:削除、false:未削除
   */
  public closePopUp(component: any): boolean {
    if (component.closeFunction != null) {
      component.closeFunction();
      return true;
    } else {
      return false;
    }
  }

  /**
   * plessTitleWindowを表示しているか判定
   *
   */
  public isOpened():boolean {
    return this.getMaxZIndex() > PlessDialogService.MIN_Z_INDEX;
  }
}
